import axios from "axios";

const state = {
  userInfo: {},
  verifyEmail: false,
  verifyPhone: false,
  contacts: { mail: "", phone: "" },
  tempPwd: { password: "", verifyPassword: "" },
  serverValidationErrors: [],
  testKit: [],
  testKitDetails: {},
  testkitId: null,
  back: false,
  fullname: null,
  testuser:{},
  kitversion:1
};

const mutations = {
  userFullName(state, obj) {
    state.fullname = obj;
  },
  back(state, boolean) {
    state.back = boolean;
  },
  updateUserInfo(state, order) {
    for (const key in order) {
      state.userInfo[key] = order[key];
    }
  },
  changeUserInfo(state, order) {
    state.userInfo = order;
  },
  verifyEmail(state, boolean) {
    state.verifyEmail = boolean;
  },
  verifyPhone(state, boolean) {
    state.verifyPhone = boolean;
  },
  saveNumber(state, num) {
    state.contacts = num;
  },
  saveFormPwd(state, info) {
    state.tempPwd = info;
  },
  saveTestKit(state, testkit) {
    state.testKit = testkit;
  },
  saveTestKitDetails(state, testkit) {
    state.testKitDetails = testkit;
  },
  addErrorsMessage(state, data) {
    data.errors.forEach(item => {
      state.serverValidationErrors.push({
        field: item.field,
        message: item.message
      });
    });
  },
  settestuser(state, num){
    state.testuser = num;
  },
  setkitversion (state, num){
    // Coerce to a valid version and never store undefined/null — a missing
    // kit_version from the API must not blank the version-gated Create Profile
    // step. Default to V1 when absent/unparseable.
    state.kitversion = Number(num) === 2 ? 2 : 1;
  },
  setKitVersion (state, num){
    state.kitversion = Number(num) === 2 ? 2 : 1;
  },
  setTestKitId(state, id) {
    state.testkitId = id;
  },
  clearServerValidationErrors(state) {
    state.serverValidationErrors = [];
  }
};
const actions = {
  confirmations({ commit }, data) {
    return axios.put("/v1/profile/confirmations", data);
  },
  saveNumber({ commit }, data) {
    commit("saveNumber", data);
  },
  saveFormPwd({ commit }, data) {
    commit("saveFormPwd", data);
  },
  userInfo({ commit }, order) {
    commit("updateUserInfo", order);
  },
  sendTempUserInfo({ commit, dispatch, getters }, order) {
    return axios.put(`/v1/tempregister`, order).then(res => {
      return res;
    });
  },
  sendTempSub({ commit, dispatch, getters }, order) {
    return axios.put(`/v1/tempsubmisson`, order).then(res => {
      return res;
    });
  },
  sendUserInfo({ commit, dispatch, getters }, order) {
    if (getters.back) {
      return axios.put(`/v1/register`, order).then(res => {
        const user = res.data.data.user;
        const kit = user.testkits && user.testkits.length > 0
          ? user.testkits[user.testkits.length - 1]
          : (user.kits_v2 && user.kits_v2.length > 0 ? user.kits_v2[user.kits_v2.length - 1] : null);
        if (kit) {
          commit("changeUserInfo", kit);
          commit("saveTestKit", kit);
        }
        commit("verifyEmail", !!user.confirmed_email);
        commit("verifyPhone", !!user.confirmed_phone);
        commit("saveNumber", {
          mail: user.email,
          phone:
            user.phone[0] === `1`
              ? `${user.phone}`
              : `1${user.phone}`
        });
        return res;
      });
    } else {
      return axios.post("/v1/register", order).then(res => {
        const user = res.data.data.user;
        dispatch("setCustomerTokenSession", res.data.data.token);
        dispatch("setCustomerToken", res.data.data.token);
        commit("saveRole", user.roles[0].slug);
        localStorage.setItem("role", user.roles[0].slug);
        const kit = user.testkits && user.testkits.length > 0
          ? user.testkits[user.testkits.length - 1]
          : (user.kits_v2 && user.kits_v2.length > 0 ? user.kits_v2[user.kits_v2.length - 1] : null);
        if (kit) {
          commit("setTestKitId", kit.id);
          commit("changeUserInfo", kit);
          commit("saveTestKit", kit);
        }
        commit("verifyEmail", false);
        commit("verifyPhone", false);
        return res;
      });
    }
  },
  sendUserInfoNot({ commit }, order) {
    axios.put("/v1/profile/notifications", order).then(res => {
      commit("updateUserInfo", res.data.data.user);
      if (res.data.data.user.confirmation_email_code) {
        commit("verifyEmail", true);
      }
      if (res.data.data.user.confirmation_phone_code) {
        commit("verifyPhone", true);
      }
      return true;
    });
  },
  profileNot({ commit }, order) {
    return axios.put("/v1/profile/notifications", order);
  },
  updateUserInfo({ commit }, data) {
    commit("changeUserInfo", data);
  },
  sendVerifyCode({ commit, getters, dispatch }, code) {
    const notifications = {
      notifications_sms: false,
      notifications_email: false,
      phone: `1${getters.contacts.phone}`,
      email: getters.contacts.mail
    };
    if ("phone" in code) {
      return axios.post("/v1/profile/confirm/phone", code).then(res => {
        notifications.notifications_sms = true;
        commit("updateUserInfo", res.data.data.user);
        commit("updateUserInfo", notifications);
        commit("verifyPhone", false);
        return res;
      });
    } else {
      return axios.post("/v1/profile/confirm/email", code).then(res => {
        commit("updateUserInfo", res.data.data.user);
        notifications.notifications_email = true;
        commit("updateUserInfo", notifications);
        commit("verifyEmail", false);
        return res;
      });
    }
  },
  handleErrors({ commit }, response) {
    commit("clearServerValidationErrors");
    commit("addErrorsMessage", response);
  },
  testuserdetails({ commit }, item){
    return axios
    .get("/v1/customer/testuser?kit_id="+item)
    .then(res => {
      commit("settestuser", res.data.data.tempuser);
      commit("setkitversion", res.data.data.kit_version);
      return  res.data.data.tempuser;
    })
    .catch(() => {
      // tempuser data is supplementary prefill � its absence must not block
      // or invalidate the parent activation/preview flow.
      return undefined;
    });
  },
  checkKitId({ commit, getters, dispatch}, kitId) {
    commit("updateUserInfo", kitId);
    dispatch("testuserdetails", kitId.kit_id);
    return axios
      .post("/v1/customer/testkits/preview", getters.userInfo)
      .then(res => {
        commit("changeUserInfo", res.data.data.testkit);
      });
  },
  sendFinalData({ commit, getters }, data) {
    return axios
      .put(`/v1/customer/testkits/${getters.testKitId}`, data)
      .then(res => {
        commit("customerLogin", true);
      });
  },
  saveTestKitDetails({ commit }, data) {
    commit("saveTestKitDetails", data);
  },
  simplingDetails({ commit }, data) {
    return axios.post("/v1/customer/testkits", data).then(res => {
      commit("saveReport", {});
      commit("updateUserInfo", res.data.data.testkit);
      commit("saveTestKit", res.data.data.testkit);
      commit("setTestKitId", res.data.data.testkit.id);
    });
  },
  saveTestKit({ commit }, testKit) {
    commit("saveTestKit", testKit);
    if (testKit.report) {
      commit("saveReport", testKit.report.reportSamples);
    } else {
      commit("clearReport", {});
    }
  },
  getZip({ commit }, zip) {
    return axios.get(`http://api.zippopotam.us/us/${zip}`);
  }
};
const getters = {
  verifyCodeSendedEmail() {
    return state.verifyEmail;
  },
  verifyCodeSendedPhone() {
    return state.verifyPhone;
  },
  userInfo() {
    return state.userInfo;
  },
  kit() {
    return state.userInfo.kit_id;
  },
  contacts() {
    return state.contacts;
  },
  serverValidation() {
    return state.serverValidationErrors;
  },
  testKit() {
    return state.testKit;
  },
  testKitDetails() {
    return state.testKitDetails;
  },
  testKitId() {
    return state.testkitId;
  },
  back() {
    return state.back;
  },
  contactsEmail() {
    return state.contacts.mail;
  },
  contactsPhone() {
    return state.contacts.phone;
  },
  tempPwd() {
    return state.tempPwd.password;
  },
  fullname() {
    return state.fullname;
  },
  gettestuser(){
    return state.testuser;
  },
  getkitversion(){
    return state.kitversion;
  },
  // camelCase alias: some components map "getKitVersion". Keep both names valid
  // so a casing mismatch can never resolve to `undefined` (which would blank the
  // version-gated Create Profile step in registration/StepsInfo.vue).
  getKitVersion(){
    return state.kitversion;
  },
};

export default {
  state,
  mutations,
  actions,
  getters
};
